import { Strong } from 'braid-design-system';
import type React from 'react';

const VocabHtmlTags = {
  strong: (children: React.ReactNode[]) => <Strong>{children}</Strong>,
};

export default VocabHtmlTags;
